/** @format */

import React from "react";
import { HashRouter } from "react-router-dom";

import GeneralRoutes from "./routes/GeneralRoutes";
import { CookiesContextProvider } from "./context/CookiesContextProvider";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

function App() {
  return (
    <HashRouter>
      <CookiesContextProvider>
        <meta
          name="Description"
          content={process.env.REACT_APP_META_DESCRIPTION.toString().replaceAll(
            "_",
            " "
          )}
        />
        <title>
          {process.env.REACT_APP_META_TITLE.toString().replaceAll("_", " ")}
        </title>
        <GeneralRoutes>
          {(routeProps) => <GeneralRoutes routeProps={routeProps} />}
        </GeneralRoutes>
      </CookiesContextProvider>
    </HashRouter>
  );
}

export default App;
